import React from 'react'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import Image from '../common/Image';
import noImageUrl from '../../img/no_image_small.jpg';

const useStyles = makeStyles((theme) => ({
    businessProfileCardMin: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: theme.palette.grey[50],
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        },
    },
    imageContainer: {
        flexShrink: 0,
        width: '60px',
        height: '60px',
        borderRadius: '10%',
        overflow: 'hidden',
        border: `1px solid ${theme.palette.primary.main}`,
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
    },
    userInfo: {
        flex: 1,
    },
    userName: {
        fontSize: '1.4rem',
        fontWeight: 600,
        color: theme.palette.info.main,
        margin: 0,
        lineHeight: 1.2,
    },
}));

const BusinessProfileCardMin = props => {
    const classes = useStyles();
    const { user } = props;

    return (
        <Box className={classes.businessProfileCardMin}>
            <Box className={classes.imageContainer}>
                {
                    user.profile.avatar
                        ? <Image src={user.profile.avatar.image_url} size={'200'} alt="avatar" />
                        : <img src={noImageUrl} alt="noImage" />
                }
            </Box>
            <Box className={classes.userInfo}>
                <Typography variant="h6" className={classes.userName}>
                    {user.name}
                </Typography>
            </Box>
        </Box>
    )
}

BusinessProfileCardMin.propTypes = {
    user: PropTypes.object.isRequired
}

export default BusinessProfileCardMin
